import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=21be70a5"
import script from "./CategoryTable.vue?vue&type=script&lang=ts"
export * from "./CategoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports